import { Component, OnInit, forwardRef, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PlaceService } from '../../_services/place.service';

@Component({
  selector: 'app-country-autocomplete',
  templateUrl: './country-autocomplete.component.html',
  styleUrls: ['./country-autocomplete.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountryAutocompleteComponent),
      multi: true
    }
  ]
})
export class CountryAutocompleteComponent implements ControlValueAccessor {
  @Input() placeholder: any = "N'importe quel Pays";
  @Input() value;
  @Input() allowAdd: boolean = false;
  @Output() notFound: EventEmitter<string> = new EventEmitter<string>();
  propagateChange = (_: any) => { };

  private countries: object[];
  private selected: object;
  private showResults: boolean = false;
  private noResults: boolean = false;


  constructor(private service: PlaceService, private elRef: ElementRef) {
  }

  writeValue(value: any): void {
    if (value !== undefined && value !== "" && value !== null) {
      // If an Object is given, just take the ID as value
      if (value instanceof Object) {
        this.value = value.id;
      } else {
        this.value = value;
      }
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  changeValue(value) {
    this.propagateChange(value);
  }

  search(value) {
    this.service.autocompleteCountries(value || '').subscribe(response => {
      this.countries = response;
      this.noResults = !this.countries.length;
    });
  }

  ngOnInit() {
  }

  selectResult(country) {
    this.elRef.nativeElement.querySelector('#countrySearchInput').value = country.name;
    this.changeValue(country.id);
  }

  onFocus() {
    this.search('');
    this.showResults = true;
  }

  onBlur() {
    setTimeout(function () {
      this.showResults = false;
    }.bind(this), 200);
  }

  triggerAdd(countryName) {
    this.notFound.emit(countryName);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/country-autocomplete/country-autocomplete.component.ts